/* eslint-disable @typescript-eslint/no-explicit-any */
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export default function CardSkeleton(props: any) {
  const { isSelected } = props;

  if (isSelected)
    return (
      <div className="flex">
        <AspectRatio ratio={100 / 71} className={cn("relative")}>
          <Skeleton className="absolute inset-0" />
          <div className="absolute ltr:-right-[400px] ltr:2xl:-right-[520px] rtl:-left-[400px] rtl:2xl:-left-[520px]">
            <Skeleton className="mb-2 h-10 w-[380px] 2xl:w-[470px]" />
            <Skeleton className="mb-4 h-6 w-1/2" />
            <Skeleton className="mb-4 h-4 w-full max-w-sm" />
            <Skeleton className="mt-4 h-4 w-full max-w-md" />
            <Skeleton className="mt-4 h-4 w-full max-w-md" />
          </div>
        </AspectRatio>
      </div>
    );

  return (
    <AspectRatio ratio={100 / 71} className={cn("relative")}>
      <Skeleton className="absolute inset-0" />
    </AspectRatio>
  );
}
